import React, {Component} from 'react';
import {connect} from 'react-redux';
// style
import style from '../css/giftForYou.css';
// helpers
import {getText} from '../../../helpers/localization';
// identifiers
// actions
// configurations
import {OPERATOR} from '../../../constants/operator';
import {ASSETS_URL} from "../../../constants/endpoints";
import {getItem, setItem} from "../../../helpers/localStorageHelpers";
import {HIDE_GIFT_FOR_YOU, HIDE_GIFT_TILL} from "../../../constants/localStorage";
import {isLocalStorageAvailable} from "../../../helpers/systemHelpers";
import {openGiftForYou, openCloseMyOffer, doNotShowCheckBox} from "../../../actions/promoBetActions";
import {ModalButton} from "./modalButton";
const mapStateToProps = (state, ownProps) => {
    return {
        isModalOpen: state.vpp.isModalOpen,
        openModalType: state.vpp.openModalType,
        selectedOddsType: state.vpp.selectedOddsType,
        systemLanguage: state.vpp.systemLanguage,
        isVideoVisible: state.vpp.isVideoVisible,
        doNotShow: state.vpp.doNotShow
    };
};

class GiftForYou extends Component {
    constructor(props) {
        super(props);

        let store = this.props.store;
        let storeData = store.getState();
        this.state = {
            doNotShow: storeData.vpp.doNotShow
        }

    }
    toggleCheckBox(){
        this.props.store.dispatch(doNotShowCheckBox());
    }
    render() {
        let store = this.props.store;
        let accaPrizeBoost = JSON.parse(OPERATOR.accaBoostBonusPercentage);
        let maxAccaPrice = Object.entries(accaPrizeBoost).sort((x, y) => y[1] - x[1])[0]
        let minAccaPrice = Object.entries(accaPrizeBoost).sort((x, y) => x[1] - y[1])[0]
        let betType = (<span>{getText('BET_TYPE', store)}</span>)
        let boost = (<span>{getText('BOOST', store)}</span>)

        const _getOffers = () => {
            let storeData = store.getState();
            if (isLocalStorageAvailable && storeData.vpp.doNotShow) {
                setItem(storeData.vpp.playerUID, HIDE_GIFT_FOR_YOU, true);
                let hideGiftForYouTill = 10;
                const currentTimeAsMs = Date.now();
                const adjustedTimeAsMs = currentTimeAsMs + (1000 * 60 * 60 * 24 * hideGiftForYouTill);
                setItem(storeData.vpp.playerUID, HIDE_GIFT_TILL, adjustedTimeAsMs);
            }

            if (storeData.vpp.isGiftForYouOpen) {
                this.props.store.dispatch(openGiftForYou());
            }
            if ((!this.state.isMyOffersPopupOpen)) {
                this.props.store.dispatch(openCloseMyOffer());
            }
        }
       let button =(<ModalButton title = {"View_Offers"} onClick = {_getOffers} store={this.props.store}/>);
        return (
            <div className={style.giftIcon}>
                <div className={style.giftIcon}>
                    <img className={style.promoGiftIcon} src={`${ASSETS_URL}promo/giftForYouIcon.gif`}/>
                </div>
                <div className={style.promoHeading}>{getText('Gift_for_You_Heading', this.props.store)}</div>
                <div className={style.promoSubHeading}>
                    {getText('Gift_for_You_Content', this.props.store)}
                </div>
                {button}
                <div className={style.doNotShowText}>
                    <input className={style.checkboxs} type={"checkbox"} name={'doNotShow'} onClick={(e)=> { this.toggleCheckBox()}}/>
                    <label className={style.label}>{getText('Do_Not_Show_MSG', this.props.store)}</label>
                </div>
            </div>
        );
    }
}

export default connect(mapStateToProps)(GiftForYou);



// WEBPACK FOOTER //
// ./src/ui-modules/sports-book/components/giftForYou.js